import { Helmet } from 'react-helmet-async'

const SITE_NAME = 'Fenica'

/**
 * SEO component — quản lý <title> và <meta> cho từng trang.
 *
 * @param {string}  title        - Tiêu đề trang (bắt buộc)
 * @param {string}  [description] - Mô tả trang cho meta description
 * @param {string}  [canonical]   - URL canonical của trang (optional)
 */
function SEO({ title, description, canonical }) {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : SITE_NAME

  return (
    <Helmet>
      <title>{fullTitle}</title>

      {description && (
        <meta name="description" content={description} />
      )}

      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      {description && (
        <meta property="og:description" content={description} />
      )}
      <meta property="og:site_name" content={SITE_NAME} />

      {/* Canonical */}
      {canonical && <link rel="canonical" href={canonical} />}
    </Helmet>
  )
}

export default SEO
